import React, { useEffect, useState } from "react";
import firebase from "firebase";
import { db, storage } from "../base";
import Layout from "../layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileCode } from "@fortawesome/free-solid-svg-icons";
import ListProduitsClients from "../components/fichiers-produits-clients/ListProduitsClients";
import "./fichiers.scss";

const FichiersProduitsClients = () => {
  const [urlDownload, setUrlDownload] = useState([]);
  const [json, setJson] = useState(null);
  const [url, setUrl] = useState(null);
  const [progress, setProgress] = useState(0);
  const [showProgress, setShowProgress] = useState("inactive");
  const [showProgressBar, setShowProgressBar] = useState("progress-bar hide");
  const collection = "json";

  useEffect(() => {
    db.collection(collection)
      .orderBy("timestamp", "desc")
      .onSnapshot((snapshot) => {
        setUrlDownload(
          snapshot.docs.map((doc) => ({
            id: doc.id,
            url: doc.data().url,
            name: doc.data().name,
          }))
        );
      });
  }, []);

  const handleChangeUpload = (e) => {
    if (e.target.files[0]) {
      setJson(e.target.files[0]);
    }
  };

  const progress_bars = document.querySelectorAll(".progress");
  progress_bars.forEach((bar) => {
    bar.style.width = `${progress}%`;
  });

  const handleUpload = () => {
    const uploadTask = storage.ref(`json/${json.name}`).put(json);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        setProgress(progress);
        setShowProgressBar("progress-bar show");
      },
      (error) => {
        console.log(error);
      },
      () => {
        storage
          .ref(collection)
          .child(json.name)
          .getDownloadURL()
          .then((url) => {
            setUrl(url);
            db.collection(collection).doc(json.name).set(
              {
                url: url,
                name: json.name,
                timestamp: firebase.firestore.FieldValue.serverTimestamp(),
              },
              { merge: true }
            );
          });
        setTimeout(() => {
          setShowProgressBar("progress-bar hide");
        }, 1000);
        setTimeout(() => {
          setProgress(0);
        }, 2000);
      }
    );
    setJson(null);
  };

  return (
    <Layout title={"Admin Fichiers Produits"}>
      <div id="fichiers" className="pages">
        <section>
          <div className="div-button-upload">
            <div className="divs width29">
              <h2>Ajouter un fichier</h2>
              <label for="upload" className="label-icon">
                <FontAwesomeIcon icon={faFileCode} />
              </label>
              <input
                id="upload"
                className="input-upload"
                type="file"
                accept=".json"
                onChange={handleChangeUpload}
              />
              <button
                className="button-upload"
                disabled={!json}
                onClick={handleUpload}
              >
                Envoyer
              </button>
              <div className={showProgressBar}>
                <div className="progress" data-size={showProgress} />
                <p>{progress} %</p>
              </div>
            </div>
            <div className="width69">
              <ul className="affiches-pdf">
                {urlDownload.map((json) => (
                  <ListProduitsClients key={json.id} json={json} />
                ))}
              </ul>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default FichiersProduitsClients;
